<div class="hot-table sku-config-table hot-header-align">
  <hot-table [hotId]="hotTableId" [settings]="hotTableSettings" [licenseKey]="handsontableLicenseKey"></hot-table>
</div>

